export default __webpack_public_path__ + "static/media/icon-visa.bad66ee6947b276cb4c848f3a62158d2.svg";